import { newDocumentoSelector } from "features/Crear/redux/selectors/newDocumentoSelectors"
import { newDocumentoSettingsSelector } from "features/Crear/redux/selectors/newDocumentoSettingsSelectors"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { useTranslation } from "react-i18next"
import {
  setShowDiasPagoModal,
  setShowFormaPagoModal,
} from "../../redux/slices/newDocumentoSettingsSlice"
import { ButtonAction } from "../ConceptosTable"

const DocumentoFormInstruccionesDePago = ({
  formaPagoDescription,
  formaPagoIban,
  diasPago,
  setIsEditFormaPago,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const { colorSelected, showFormaPago, showDiasPago } = useSelector(
    newDocumentoSettingsSelector
  )
  const { librado } = useSelector(newDocumentoSelector)

  const dispatch = useDispatch()

  return (
    (showFormaPago || showDiasPago) && (
      <div className='mt-2 border-0 card'>
        <div
          style={{ backgroundColor: colorSelected }}
          className='card-header header-blue'
        >
          {t("crear.facturaRec.paymentInstructionLabel")}
        </div>

        <div className='p-1 text-left card-body'>
          {showFormaPago && (
            <>
              <p className='pb-0 mb-0 d-flex align-items-center'>
                {t("crear.facturaRec.paymentFormLabel")}
                {formaPagoDescription}
                <ButtonAction
                  onClick={() => {
                    // @ts-expect-error TS(2345): Argument of type...
                    dispatch(setShowFormaPagoModal(true))
                    setIsEditFormaPago(true)
                  }}
                  iconName='pen'
                  classNameIcon='btn-concept__icon'
                />
              </p>
              {((formaPagoDescription === "Transferencia" && formaPagoIban) ||
                (formaPagoDescription === "Pago Domiciliado" &&
                  librado &&
                  formaPagoIban)) && (
                <p>
                  {t("crear.facturaRec.paymentFormIbanLabel", {
                    iban: formaPagoIban,
                  })}
                </p>
              )}
            </>
          )}

          {showDiasPago && (
            <p className='d-flex align-items-center'>
              {t("crear.facturaRec.paymanetDaysLabel")}
              {diasPago}
              <ButtonAction
                // @ts-expect-error TS(2345): Argument of type...
                onClick={() => dispatch(setShowDiasPagoModal(true))}
                iconName='pen'
                classNameIcon='btn-concept__icon'
              />
            </p>
          )}
        </div>
      </div>
    )
  )
}

export default DocumentoFormInstruccionesDePago
